import React from "react";
import { Switch } from "react-router-dom";
import ASN from "../pages/ASN";
import AsnCrear from "../pages/ASN/AsnCrear";
import SubmitASN from "../pages/ASN/SubmitASN";
import ViewASN from "../pages/ASN/ViewASN";
import AuthorizeEntryPlant from "../pages/AuthorizeEntryPlant";
import Blank from "../pages/Blank";
import Concierge from "../pages/Concierge";
import Manage from "../pages/Concierge/Manage";
import Conference100 from "../pages/Conference/Conference100";
import Conference100InsertUpdate from "../pages/Conference/Conference100/InsertUpdate";
import Conference100Register from "../pages/Conference/Conference100/Register";
import DebitInsert from "../pages/Conference/DebitInsert";
import DebitSearch from "../pages/Conference/DebitSearch";
import MDFe from "../pages/MDFe";
import MonitoringPanel from "../pages/MonitoringPanel";
import MovementType from "../pages/MovementType";
import Mvc from "../pages/Mvc";
import SubmitMvc from "../pages/Mvc/Submit";
import Mvm from "../pages/Mvm";
import InsertMvmInvoice from "../pages/Mvm/AddMvmInvoice";
import AddMvmOutgoingInvoice from "../pages/Mvm/AddMvmOutgoingInvoice";
import AddMvmOutgoingMaterialInvoice from "../pages/Mvm/AddMvmOutgoingMaterialInvoice";
import AddMvmOutgoingRequest from "../pages/Mvm/AddMvmOutgoingRequest";
import AddMvmTransportOrder from "../pages/Mvm/AddMvmTransportOrder";
import CheckIn from "../pages/Mvm/CheckIn";
import CheckOut from "../pages/Mvm/CheckOut";
import CritialMaterialCall from "../pages/Mvm/CritialMaterialCall";
import EKanban from "../pages/Mvm/E-Kanban";
import ExportRacks from "../pages/Mvm/ExportRacks";
import MvmMonitors from "../pages/Mvm/Monitor";
import MvmExternalQueueMonitor from "../pages/Mvm/Monitor/ExternalQueue";
import MvmAutomatico from "../pages/Mvm/MvmAutomatico";
import MvmCompositionForm from "../pages/Mvm/MvmCompositionForm";
import MvmInvoiceSearch from "../pages/Mvm/MvmInvoiceSearch";
import OutgoingInvoiceRequest from "../pages/Mvm/OutgoingInvoiceRequest/Search/index";
import SubmitOutgoingInvoiceRequest from "../pages/Mvm/OutgoingInvoiceRequest/Submit";
import PendingAccounting from "../pages/Mvm/PendingAccounting";
import PendingBilling from "../pages/Mvm/PendingBilling";
import PendingTransportOrderMonitor from "../pages/Mvm/PendingTransportOrder";
import RegisterVehicleArrival from "../pages/Mvm/RegisterVehicleArrival";
import ShedCheckout from "../pages/Mvm/ShedCheckout";
import SubmitMvm from "../pages/Mvm/SubmitMvm";
import VehicleStayTimeMonitor from "../pages/Mvm/VehicleStayTime";
import NoPermission from "../pages/NoPermission";
import PackingFcm from "../pages/PackingFcm";
import Parameter from "../pages/Parameter";
import BillingRecordReport from "../pages/Report/BillingRecord";
import BusinessSecurity from "../pages/Report/BusinessSecurity";
import MvmGeneralData from "../pages/Report/MvmGeneralData";
import MvmListReport from "../pages/Report/MvmList";
import MvmNoWindowJustificationReport from "../pages/Report/MvmNoWindowJustification";
import PendingAccountingReport from "../pages/Report/PendingAccounting";
import PendingXMLRequest from "../pages/Report/PendingXMLRequest";
import ScheduledBalance from "../pages/Report/ScheduledBalance";
import ShedMovementReport from "../pages/Report/ShedMovement";
import ShippingRequestReport from "../pages/Report/ShippingRequestReport";
import Security from "../pages/Security";
import Shed from "../pages/Shed";
import ShedRegistration from "../pages/Shed/ShedRegistration";
import ShippingRequest from "../pages/ShippingRequest";
import ShippingRequestManageSuppliers from "../pages/ShippingRequest/ManageSuppliers";
import ShippingRequestMonitor from "../pages/ShippingRequest/Monitor";
import ShippingRequestView from "../pages/ShippingRequest/ShippingRequestView";
import Submit from "../pages/ShippingRequest/Submit";
import ShippingRequestValidateInvoice from "../pages/ShippingRequest/ValidateInvoice";
import SignIn from "../pages/SignIn";
import Teste from "../pages/Teste";
import Vehicle from "../pages/Vehicle";
import VehicleType from "../pages/VehicleType";
import MaterialUnloadShed from "../pages/MaterialUnloadShed";
import Window from "../pages/Window";
import WindowFiape from "../pages/WindowFiape";
import Route from "./route";
import AddMvmShed from "../pages/Mvm/AddMvmShed";
import RemoveCache from "../pages/RemoveCache";
import Documentation from "../pages/Documentation";

const Routes: React.FC = () => (
    <Switch>
        <Route
            path="/Version"
            component={() => {
                return (<div className="row center"><br />{import.meta.env.REACT_APP_VERSION}</div>);
                } } isPrivate
        />
        <Route path="/" exact component={Security} />
        <Route path="/Sign" component={SignIn} />
        <Route path="/Blank" component={Blank} isPrivate />
        <Route path="/Concierge" component={Concierge} isPrivate />
        <Route path="/Window" component={Window} isPrivate />
        <Route path="/Vehicle" component={Vehicle} isPrivate />
        <Route path="/Parameter" component={Parameter} isPrivate />
        <Route path="/Mvc" component={Mvc} isPrivate />
        <Route path="/Mvm" component={Mvm} isPrivate />
        <Route path="/MvmAutomatico" component={MvmAutomatico} isPrivate />
        <Route path="/SubmitMvm" component={SubmitMvm} isPrivate exact={true} />
        <Route path="/SubmitMvm" component={SubmitMvm} isPrivate />
        <Route path="/WindowFiape" component={WindowFiape} isPrivate />
        <Route path="/AddMvmInvoice" component={InsertMvmInvoice} isPrivate />
        <Route path="/SearchEkanbanInvoices" component={EKanban} isPrivate />
        <Route
            path="/AddMvmOutgoingRequest"
            component={AddMvmOutgoingRequest}
            isPrivate
        />
        <Route
            path="/AddMvmOutgoingMaterialInvoice"
            component={AddMvmOutgoingMaterialInvoice}
            isPrivate
        />
        <Route
            path="/AddMvmOutgoingInvoice"
            component={AddMvmOutgoingInvoice}
            isPrivate
        />
        <Route
            path="/AddMvmShed"
            component={AddMvmShed}
            isPrivate
        />
        <Route
            path="/MvmInvoiceSearch"
            component={MvmInvoiceSearch}
            isPrivate
        />
        <Route path="/Teste" component={Teste} isPrivate />
        <Route path="/PackingFcm" component={PackingFcm} isPrivate />
        <Route path="/VehicleType" component={VehicleType} isPrivate />
        <Route path="/MaterialUnloadShed" component={MaterialUnloadShed} isPrivate />
        <Route
            path="/RegisterVehicleArrival"
            component={RegisterVehicleArrival}
            isPrivate
        />
        <Route
            path="/PendingAccounting"
            component={PendingAccounting}
            isPrivate
        />
        <Route path="/Manage" component={Manage} isPrivate />
        <Route
            path="/ShedManage/:tabIndex?"
            component={AuthorizeEntryPlant}
            isPrivate
        />
        <Route path="/CheckIn" component={CheckIn} isPrivate />
        <Route path="/MovementType" component={MovementType} isPrivate />
        <Route path="/CheckOut" component={CheckOut} isPrivate />
        <Route path="/ExportRacks" component={ExportRacks} isPrivate />
        <Route
            path="/ShedRegistration"
            component={ShedRegistration}
            isPrivate
        />
        <Route path="/PendingBilling" component={PendingBilling} isPrivate />
        <Route path="/Shed" component={Shed} isPrivate />
        <Route
            path="/ShedCheckout/:checkoutType/:mvmId?/shed/:shedId?/movType/:movementTypeId?"
            component={ShedCheckout}
            isPrivate
        />
        <Route
            path="/PendingTransportOrder"
            component={PendingTransportOrderMonitor}
            isPrivate
        />
        <Route path="/MvmMonitor" component={MvmMonitors} isPrivate />

        <Route path="/ExternalQueueMonitor" component={MvmExternalQueueMonitor} isPrivate />
        <Route
            path="/AddMvmTransportOrder/:mvmId"
            component={AddMvmTransportOrder}
            isPrivate
        />
        <Route
            path="/CriticalMaterialCall"
            component={CritialMaterialCall}
            isPrivate
        />
        <Route
            path="/VehicleStayTimeMonitor"
            component={VehicleStayTimeMonitor}
            isPrivate
        />
        <Route path="/ASN/:discriminator?" component={ASN} isPrivate />
        <Route path="/SubmitASN/:asnId?" component={SubmitASN} isPrivate />
        <Route path="/CrearASN/:asnId?" component={AsnCrear} isPrivate />
        <Route path="/ViewASN/:asnId?" component={ViewASN} isPrivate />
        <Route path="/DebitSearch" component={DebitSearch} isPrivate />
        <Route path="/ShippingRequest/Submit" component={Submit} isPrivate />
        <Route
            path="/ShippingRequest/ValidateInvoice"
            component={ShippingRequestValidateInvoice}
            isPrivate
        />
        <Route path="/ShippingRequest/Duplicate" component={Submit} isPrivate />
        <Route path="/ShippingRequest/Validate" component={Submit} isPrivate />
        <Route
            path="/ShippingRequest/View/:id?"
            component={ShippingRequestView}
            isPrivate
        />
        <Route path="/Conference100" component={Conference100} isPrivate />
        <Route
            path="/Conference100-Register"
            component={Conference100Register}
            isPrivate
        />
        <Route
            path="/Conference100-InsertUpdate"
            component={Conference100InsertUpdate}
            isPrivate
        />
        <Route path="/DebitInsert/:Id?" component={DebitInsert} isPrivate />
        <Route path="/ShippingRequest" component={ShippingRequest} isPrivate />
        <Route
            path="/ShippingRequestManageSuppliers"
            component={ShippingRequestManageSuppliers}
            isPrivate
        />
        <Route path="/MonitoringPanel" component={MonitoringPanel} isPrivate />
        <Route
            path="/ShippingRequestMonitor"
            component={ShippingRequestMonitor}
            isPrivate
        />
        <Route
            path="/report/BillingRecord"
            component={BillingRecordReport}
            isPrivate
        />
        <Route
            path="/report/MvmNoWindowJustification"
            component={MvmNoWindowJustificationReport}
            isPrivate
        />
        <Route
            path="/report/ShedMovement"
            component={ShedMovementReport}
            isPrivate
        />
        <Route
            path="/report/PendingXmlRequest"
            component={PendingXMLRequest}
            isPrivate
        />
        <Route
            path="/report/PendingAccounting"
            component={PendingAccountingReport}
            isPrivate
        />
        <Route
            path="/report/ScheduledBalance"
            component={ScheduledBalance}
            isPrivate
        />
        <Route
            path="/report/BusinessSecurity"
            component={BusinessSecurity}
            isPrivate
        />
        <Route
            path="/report/ShippingRequest"
            component={ShippingRequestReport}
            isPrivate
        />
        <Route path="/report/MvmGeneralData" component={MvmGeneralData} isPrivate />
        <Route path="/report/MvmList" component={MvmListReport} isPrivate />

        <Route path="/OutgoingInvoiceRequest" component={OutgoingInvoiceRequest} isPrivate />
        <Route path="/SubmitOutgoingInvoiceRequest" component={SubmitOutgoingInvoiceRequest} isPrivate />

        <Route path="/NoPermission" component={NoPermission} isPrivate />
        <Route path="/SubmitMvc" component={SubmitMvc} isPrivate />
        <Route path="/MvmComposition" component={MvmCompositionForm} isPrivate />

        <Route path="/MDFe" component={MDFe} isPrivate />
        <Route path="/RemoveCache" component={RemoveCache} isPrivate />
        <Route path="/Documentation" component={Documentation} isPrivate />
    </Switch>
);

export default Routes;
